// index.tsx
// (c) NCR Voyix Corporation 2025. All rights reserved.

import React from 'react'
import { AppShell } from '@ncr-design-system/pattern-app-shell'
import { Outlet } from 'react-router-dom'
import { connect } from 'react-redux'
import Box from '@mui/material/Box'
import { RootState } from '../../redux'
import Appbar from './Appbar'
import SideBar from './SideBar'
import { AppBarHeight } from '../../common/constants/sizeConstants'

function mapStateToProps(state: RootState) {
  return {
    user: state.user
  }
}
export type AppShellContainerProps = ReturnType<typeof mapStateToProps>;

export function AppShellContainer({
  user
}: Readonly<AppShellContainerProps>): JSX.Element {
  return (
    <AppShell
      type="persistent"
      components={{
        appbar: <Appbar user={user} />,
        sidebar: <SideBar />
      }}
      openSidebar
      overrides={{
        appbar: {
          sx: {
            height: AppBarHeight
          }
        }
      }}
    >
      <Box
        sx={{
          bgcolor: '#FAFAFA',
          paddingTop: `${AppBarHeight}px`,
          height: '100%',
          overflow: 'auto'
        }}
      >
        <Box
          sx={{
            padding: 3
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </AppShell>
  )
}

export default connect(mapStateToProps)(AppShellContainer)
